<template>
    <div class="position-relative w-100">
        <button
            ref="trigger"
            type="button"
            class="btn btn-sm w-100 d-flex align-items-center justify-content-center collapsed-dropdown-btn"
            :class="{ 'collapsed-dropdown-btn--open': isOpen }"
            :title="title"
            @click.stop="toggle"
        >
            <i :class="['fas', `fa-${icon}`, 'cd-trigger-icon']"></i>
            <i
                class="fas fa-caret-right cd-trigger-caret"
                :class="{ 'cd-trigger-caret--open': isOpen }"
            ></i>
        </button>
        <Teleport to="body">
            <div
                v-if="isOpen"
                ref="menu"
                class="collapsed-dropdown-menu"
                :style="menuStyle"
                @click.stop
            >
                <slot :close="close" />
            </div>
        </Teleport>
    </div>
</template>

<script>
export default {
    props: {
        icon: { type: String, required: true },
        title: { type: String, default: "" }
    },
    data() {
        return {
            isOpen: false,
            menuStyle: {}
        };
    },
    mounted() {
        document.addEventListener("click", this.onDocClick);
        document.addEventListener("keydown", this.onKey);
        window.addEventListener("resize", this.updatePosition);
        window.addEventListener("scroll", this.updatePosition, true);
    },
    unmounted() {
        document.removeEventListener("click", this.onDocClick);
        document.removeEventListener("keydown", this.onKey);
        window.removeEventListener("resize", this.updatePosition);
        window.removeEventListener("scroll", this.updatePosition, true);
    },
    methods: {
        toggle() {
            if (this.isOpen) {
                this.close();
            } else {
                this.open();
            }
        },
        open() {
            this.isOpen = true;
            this.$nextTick(this.updatePosition);
        },
        close() {
            this.isOpen = false;
        },
        updatePosition() {
            const trigger = this.$refs.trigger;
            if (!trigger) return;
            const rect = trigger.getBoundingClientRect();
            this.menuStyle = {
                position: "fixed",
                top: `${Math.max(rect.top, 8)}px`,
                left: `${rect.right + 4}px`,
                zIndex: 21000
            };
        },
        onDocClick(event) {
            if (!this.isOpen) return;
            const menu = this.$refs.menu;
            if (menu && menu.contains(event.target)) return;
            this.close();
        },
        onKey(event) {
            if (event.key === "Escape" && this.isOpen) this.close();
        }
    }
};
</script>

<style scoped>
.collapsed-dropdown-btn {
    position: relative;
    background-color: transparent;
    color: var(--side-nav-text, var(--forkto-ink-2));
    border: none;
    padding: 0.6rem 0.35rem;
    line-height: 1;
}

.collapsed-dropdown-btn:hover,
.collapsed-dropdown-btn:focus-visible {
    background-color: var(--side-nav-hover, var(--forkto-sunk));
    color: var(--side-nav-active-text, var(--forkto-ink-1));
}

.collapsed-dropdown-btn:focus {
    outline: none;
}

.collapsed-dropdown-btn:focus-visible {
    box-shadow: 0 0 0 3px var(--forkto-focus-ring);
}

.collapsed-dropdown-btn--open {
    background-color: var(--side-nav-active, var(--forkto-accent-soft));
}

.cd-trigger-icon {
    font-size: 1rem;
}

.cd-trigger-caret {
    position: absolute;
    top: 50%;
    right: 0.3rem;
    font-size: 0.5rem;
    color: var(--side-nav-muted, var(--forkto-ink-3));
    transform: translateY(-50%);
    transition: transform 0.12s ease-in-out;
}

.cd-trigger-caret--open {
    transform: translateY(-50%) rotate(90deg);
}
</style>

<style>
.collapsed-dropdown-menu {
    background-color: var(--forkto-surface);
    border: 1px solid var(--forkto-line);
    border-radius: var(--forkto-radius-control);
    padding: 0.5rem;
    min-width: 200px;
    max-width: 320px;
    max-height: 60vh;
    overflow-y: auto;
    box-shadow: 0 12px 32px rgba(var(--forkto-shadow-rgb), 0.16);
}

.collapsed-dropdown-menu .cd-item {
    display: block;
    padding: 0.4rem 0.6rem;
    border-radius: var(--forkto-radius-compact);
    color: var(--forkto-ink-2);
    text-decoration: none;
    cursor: pointer;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.collapsed-dropdown-menu .cd-item:hover {
    background-color: var(--forkto-sunk);
    color: var(--forkto-ink-1);
}

.collapsed-dropdown-menu .cd-item.active {
    background-color: var(--forkto-accent-soft);
    color: var(--forkto-ink-1);
    font-weight: 600;
}

.collapsed-dropdown-menu .cd-item.deactivated {
    color: var(--forkto-ink-3);
}
</style>
